import { UI, HStack, VStack } from '@genial/components';
import { Box, Progress } from 'native-base';
import { useCallback } from 'react';

import { SubscriptionTimeLimitType } from '../../../../../../store/subscription/types';

export interface SubscriptionTimeLimitProps {
  type: SubscriptionTimeLimitType;
  daysToDeadline: number;
  daysSinceDeadline: number;
  isMobile?: boolean;
}

export const SubscriptionTimeLimit = ({
  type,
  daysToDeadline,
  daysSinceDeadline,
  isMobile,
}: SubscriptionTimeLimitProps) => {
  const getPercentage = useCallback(() => {
    return Math.max(3, 100 - (daysToDeadline * 100) / daysSinceDeadline);
  }, [daysToDeadline, daysSinceDeadline]);

  const getOnGoingColor = useCallback(() => {
    const percentage = getPercentage();
    if (percentage <= 50) {
      return 'feedback.success.default';
    }
    return 'feedback.error.default';
  }, [getPercentage]);

  const getCorrectText = useCallback(() => {
    if (type === 'onGoing' && daysToDeadline > 1) {
      return `Faltam ${daysToDeadline} dias`;
    }
    if (type === 'onGoing' && daysToDeadline === 1) {
      return `Falta ${daysToDeadline} dia`;
    }
    if (type === 'onGoing' && daysToDeadline === 0) {
      return 'Último dia';
    }
    if (type === 'withoutDeadline') {
      return 'Sem data limite';
    }
    return 'Evento expirado';
  }, [daysToDeadline, type]);

  const renderBar = () => {
    switch (type) {
      case 'onGoing':
        return (
          <Progress
            w="full"
            size="xs"
            value={getPercentage()}
            _filledTrack={{ bg: getOnGoingColor() }}
            bg="brand.tertiary.lightest"
          />
        );

      case 'withoutDeadline':
        return <Progress w="full" size="xs" value={100} _filledTrack={{ bg: 'neutral.medium' }} />;

      case 'expired':
        return (
          <Progress w="full" size="xs" value={100} _filledTrack={{ bg: 'neutral.lightest' }} />
        );
    }
  };

  if (isMobile) {
    return (
      <HStack w="full" alignItems="center" space="stack.quarck" justifyContent="space-between">
        <Box w="55%">{renderBar()}</Box>
        <UI.Text color="neutral.dark">{getCorrectText()}</UI.Text>
      </HStack>
    );
  }

  return (
    <VStack minW="144px" space="stack.quarck">
      <Box w="full">{renderBar()}</Box>
      <UI.Text color="neutral.darkest" variant="semibold">
        {getCorrectText()}
      </UI.Text>
    </VStack>
  );
};
